import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, Paragraph, NakedButton } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

const RefreshButton = styled(NakedButton)`
  display: block;
  color: ${themeGet('colors.ui.link')};
  text-decoration: underline;
  font-size: ${themeGet('fontSizes.lg')};
`;

const UnconnectedSearchError = ({ hasError, onRefreshClick }) => {
  if (!hasError) {
    return null;
  }

  return (
    <Box bg="ui.infoBackground" borderColor="ui.info" border={1} p={4} mb={4}>
      <Heading.h1 fontSize="xl">Oops, something went wrong.</Heading.h1>
      <Paragraph fontSize="base" mb={5}>
        We are aware there is an issue and the team is looking into it. <br />
        Try refreshing the page or come back again later.
      </Paragraph>
      <RefreshButton onClick={onRefreshClick}>Refresh the page</RefreshButton>
    </Box>
  );
};

UnconnectedSearchError.propTypes = {
  hasError: PropTypes.bool,
  onRefreshClick: PropTypes.func.isRequired,
};

UnconnectedSearchError.defaultProps = {
  hasError: false,
};

export default UnconnectedSearchError;
